import { nextTick } from 'vue'

export function useMapFocus(rootRef) {
  const focusAfterZoom = () => {
    const back = rootRef.value?.querySelector('.kb-danmarks-kort-map__back')
    if (back) { back.focus(); return }
    rootRef.value?.querySelector('button, [tabindex]:not([tabindex="-1"])')?.focus()
  }

  const focusRegionMarker = (regionKey) => nextTick(() => {
    const marker = [...(rootRef.value?.querySelectorAll('.kb-danmarks-kort-map__marker') || [])]
      .find(el => el.dataset.markerKey === regionKey)
    marker ? marker.focus() : focusAfterZoom()
  })

  return { focusAfterZoom, focusRegionMarker }
}
